module.exports = __webpack_public_path__ + "static/media/gs.e0781d5f.svg";